import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import {
  HistoricoAtencionesResponse,
  IArchivosPacienteResponse,
  IRespPaciente,
  OpcionesHistorialAtenciones,
  PatientsResponse
} from '../interfaces/paciente.interface';
import { ResponseApiModel } from '../interfaces';

export interface IListRequestOptions {
  page: number;
  size: number;
  search?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class PacienteService {

  _httpClient = inject(HttpClient)

  obtenerPacienteAtencion(idPaciente: string, idAgendamiento: string): Observable<IRespPaciente> {
    return this._httpClient.get<IRespPaciente>(`${environment.baseURL}paciente/obtener-paciente-atencion/${idPaciente}/${idAgendamiento}`);
  }

  listarPacientesDeMedico(idMedico: string, idCentroMedico: string, options: IListRequestOptions): Observable<PatientsResponse> {
    const params = new HttpParams()
      .set('page', options.page.toString())
      .set('size', options.size.toString())
      .set('search', options.search ?? '');
    return this._httpClient.get<PatientsResponse>(`${environment.baseURL}paciente/listado/medico/${idMedico}/centro-medico/${idCentroMedico}`, { params });
  }

  listarHistorialAtenciones(idPaciente: string, options: OpcionesHistorialAtenciones) {
    const { page, size } = options;
    const params = new HttpParams()
      .set('size', size.toString())
      .set('page', page.toString());
    return this._httpClient.get<HistoricoAtencionesResponse>(`${environment.baseURL}paciente/${idPaciente}/atenciones`, { params });
  }

  obtenerArchivosPacientePorCategoria(idPaciente: string, categoria: string): Observable<ResponseApiModel<Array<IArchivosPacienteResponse>>> {
    return this._httpClient.get<ResponseApiModel<Array<IArchivosPacienteResponse>>>(`${environment.baseURL}paciente/archivos/${idPaciente}/${categoria}`);
  }
}
